import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { centerable as n } from "../decorators/centerable.js";
import { stylable as r } from "../decorators/stylable.js";
import "../decorators.js";
var i = r(n({
	content: "",
	group: "block",
	attrs: t({
		type: { default: "social" },
		items: { default: void 0 }
	}),
	toDOM(t) {
		return ["div", { class: `${e.blockContainer} ${e.social} intercom-social-container` }];
	}
}));
//#endregion
export { i as socialSpec };
